import { useState, useEffect } from 'react';

export const useTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/testimonials`);
      
      if (response.ok) {
        const data = await response.json();
        // Transform the data to match the expected format
        const formattedTestimonials = (data.testimonials || []).map(testimonial => ({
          id: testimonial.id,
          name: testimonial.name,
          location: testimonial.location || '',
          text: testimonial.content,
          content: testimonial.content, // Keep both for compatibility
          rating: testimonial.rating || 5,
          image: testimonial.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(testimonial.name)}&background=random`,
          adventure: getAdventureName(testimonial.adventure_id),
          adventure_id: testimonial.adventure_id,
          featured: testimonial.featured || false,
          sort_order: testimonial.sort_order || 0,
          is_active: testimonial.is_active !== false
        }));
        
        // Sort testimonials: featured first, then by sort_order, then by creation date (newest first)
        formattedTestimonials.sort((a, b) => {
          if (a.featured && !b.featured) return -1;
          if (!a.featured && b.featured) return 1;
          if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
          return 0; // Keep original order if same priority
        });
        
        setTestimonials(formattedTestimonials);
      } else {
        throw new Error('Failed to fetch testimonials');
      }
    } catch (err) {
      console.error('Error fetching testimonials:', err);
      setError(err.message);
      // Use fallback empty array instead of static data
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  const getAdventureName = (adventureId) => {
    // This is a simple mapping - in a real app you'd fetch this from the adventures API
    const adventureTypes = {
      'camping-diving': 'Camping & Diving Trip',
      'night-dive': 'Night Dive Experience',
      'shore-dive': 'Guided Shore Dive',
      'treasure-hunt': 'Underwater Treasure Hunt',
      'scooter-dive': 'Scooter Dive Adventure',
      'dive-trip': 'Dive Trip Shore Dive'
    };
    
    return adventureTypes[adventureId] || 'Adventure Experience';
  };

  return { 
    testimonials, 
    loading, 
    error, 
    refetch: fetchTestimonials,
    totalReviews: testimonials.length,
    averageRating: testimonials.length > 0 
      ? testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length 
      : 5.0
  };
};